import styled from 'styled-components';
import { TAvatarSize } from './avatar.types';

export const clsPrefix = 'ui-avatar';

export const AVATAR_SIZE_MAP: Readonly<Record<TAvatarSize, number>> = {
  Xlarge: 96,
  large: 72,
  medium: 56,
  small: 40,
  Xsmall: 32,
} as const;

export const AvatarSC = styled.span`
  position: relative;
  width: fit-content;

  border-radius: 50%;
  border-width: 1px;
  border-color: ${({ theme }) => theme.color.border.outline};
  border-style: solid;

  &.on-dark {
    border-color: ${({ theme }) => theme.color.border.outlineDark};
  }

  /* &.is-expert {
    border-color: ${({ theme }) => theme.color.solid.accent};
  } */

  .${clsPrefix}-loader {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;

    inset: 0;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.color.surface.loader};
  }

  .${clsPrefix}-image {
    border-radius: 50%;
  }
`;
